import { Component } from "react";
import { TimePicker, Form, Divider, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { timeHrMin, currentTime, getMoment, dateFormat, dayOfWeekArray } from "@/lib/dateTime";
import { ReButton } from "@/components/refineElement";
import { modalFromLayout, selectFilterOption, getOptionArray } from "@/lib/antdElementFunction";
import { hasPermission } from "@/lib/permissionUtil";

interface props {
  form?: any;
  busTimeInfo: any;
  handleType: string;
  clickDelete: any;
  activeDayKey: number;
}

class ModalBusTime extends Component<props> {
  busT: any = getLangList("bus");
  buttonT: any = getLangList("button");

  componentDidMount() {
    const { form, busTimeInfo, handleType } = this.props;
    const { busTime, startTime, endTime } = busTimeInfo ?? {};

    if (handleType === 'update') {
      form.setFieldsValue({
        busTime: getMoment(`${currentTime.format(dateFormat)} ${busTime}`),
        busTimeReal: [
          getMoment(`${currentTime.format(dateFormat)} ${startTime}`),
          getMoment(`${currentTime.format(dateFormat)} ${endTime}`)
        ],
      });
    }
  }

  render() {
    const { form, handleType, clickDelete, activeDayKey } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          busTime: currentTime,
          busTimeReal: [currentTime, currentTime],
          dayOfWeek: dayOfWeekArray[activeDayKey - 1],
        }}
      >
        <Form.Item name="dayOfWeek" label={this.busT.DAY_OF_WEEK} rules={[{ required: true }]}>
          <Select
            optionFilterProp="children"
            filterOption={(input: any, option: any) => selectFilterOption(input, option)}
          >
            {getOptionArray([
              { label: '一', value: 'ㄧ' },
              { label: '二', value: '二' },
              { label: '三', value: '三' },
              { label: '四', value: '四' },
              { label: '五', value: '五' },
              { label: '六', value: '六' },
              { label: '日', value: '日' },
            ])}
          </Select>
        </Form.Item>

        <Form.Item label={this.busT.TIME_SHOW} name="busTime" rules={[{ required: true }]}>
          <TimePicker format={timeHrMin} allowClear={false} />
        </Form.Item>

        <Form.Item label={this.busT.TIME_REAL} name="busTimeReal" rules={[{ required: true }]}>
          <TimePicker.RangePicker format={timeHrMin} allowClear={false} />
        </Form.Item>

        {handleType === 'update' && hasPermission('BUS_DELETE') &&
          <>
            <Divider dashed />
            <Form.Item label={this.buttonT.DELETE}>
              <ReButton onClick={clickDelete} attributeObject={{ type: "danger" }} iconName='delete' />
            </Form.Item>
          </>
        }
      </Form >
    );
  }
}

export default ModalBusTime;